import { render, staticRenderFns } from "./ProductReasonsWithTableField.vue?vue&type=template&id=04af1282"
import script from "./ProductReasonsWithTableField.vue?vue&type=script&lang=js"
export * from "./ProductReasonsWithTableField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports